import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/auth';
import { useLanguage } from '@/context/language-context';
import Layout from '@/components/layout/Layout';
import EscortDashboardLayout from '@/components/escort-dashboard/EscortDashboardLayout';
import EscortDashboardOverview from '@/components/escort-dashboard/EscortDashboardOverview';
import { toast } from '@/components/ui/use-toast';

const EscortDashboard: React.FC = () => {
  const { user, isLoading } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    // Vérifier si l'utilisateur est connecté et a le rôle d'escort
    if (!isLoading && user) {
      if (user.role !== 'escort') {
        toast({
          title: t('escort:dashboard.access_denied'),
          description: t('escort:dashboard.escort_only'),
          variant: 'destructive',
        });
        navigate('/');
      }
    } else if (!isLoading && !user) {
      // Rediriger vers la page de connexion si non connecté
      toast({
        title: t('escort:dashboard.login_required'),
        description: t('escort:dashboard.please_login'),
        variant: 'destructive',
      });
      navigate('/login');
    }
  }, [user, isLoading, navigate, t]);

  if (isLoading) {
    return (
      <Layout>
        <div className="container mx-auto py-8 flex items-center justify-center min-h-[70vh]">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        </div>
      </Layout>
    );
  }

  if (!user || user.role !== 'escort') {
    return null; // La redirection sera gérée dans l'useEffect
  }

  return (
    <Layout>
      <EscortDashboardLayout>
        <EscortDashboardOverview />
      </EscortDashboardLayout>
    </Layout>
  );
};

export default EscortDashboard;
